import { ReactElement, ReactNode, ReactPortal } from 'react'
import { createPortal } from 'react-dom'
import { createRoot, Root } from 'react-dom/client'

/**
 * React 18のcreateRoot APIをラップし、rootインスタンスを管理する
 *
 * 同じコンテナに対して複数回createRootを呼ぶことを防ぎ、メモリリークを回避する
 */

// コンテナごとにrootインスタンスを保持するWeakMap
const rootMap = new WeakMap<Element, Root>()

export function renderReact(
  element: ReactElement<any>,
  container: Element | null,
): void {
  if (!container) {
    console.error('Container element not found for React rendering')
    return
  }

  // 既存のrootがあれば再利用、なければ新規作成
  let root = rootMap.get(container)
  if (!root) {
    root = createRoot(container)
    rootMap.set(container, root)
  }

  root.render(element)
}

export function createPortalReact(
  children: ReactNode,
  container: Element,
): ReactPortal {
  return createPortal(children, container)
}

export type ReactFC<P = {}> = (
  props: P & { children?: ReactNode },
) => ReactElement<any> | null
